import React, { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { State } from "../../state";
import { RouteProps } from "../../containers/App";
import ResetRecap from "./ResetRecap";
import StoreSummary from "./StoreSummary";
import ProjectFilter, { FilterOptions } from "containers/ProjectFilter";
import ProductDistribution from "./ProductDistribution";
import SegmentationReport from "./SegmentationReport";
import PackageSummary from "./PackageSummary";
import { fetchReportStores } from "state/report_stores";
import ReportsMultiSelect from "./ReportsMultiSelect";

type ManageReportProps = PropsFromRedux & RouteProps;

interface ManageReportsState {
  selectedReportType: string;
  selectedProjectId: number;
  selectedStore: number[] | 'All';
  projectId:number;
}

class ManageReports extends Component<ManageReportProps, ManageReportsState> {
  state: ManageReportsState = {
    selectedReportType: "reset-recap",
    selectedProjectId: -1,  // -1 = none
    selectedStore: [],
    projectId:-1
  };

  reportBtns = [
    { label: "Reset Recap Report", type: "reset-recap", description: "Summary of space results" },
    { label: "Store Summary", type: "store-summary", description: "Space results at a store or state level" },
    { label: "Product Distribution", type: "product-distribution", description: "Space results for each item and their respective distributions" },
    { label: "Segmentation", type: "segmentation", description: "Space results by different breakouts" },
    { label: "Package Summary", type: "package-summary", description: "Space results by different breakouts filtered by package size" },
  ];

  handleSelect = (type: string) => {
    this.setState({ selectedReportType: type });
  };
  componentDidMount() {
    const { projectId } = this.props.match.params;
    this.setState({ projectId: parseInt(projectId) });
    this.fetchData()
  }

  componentDidUpdate(prevProps: ManageReportProps) {
    if (prevProps.match.params.projectId !== this.props.match.params.projectId) {
      this.setState({ projectId: parseInt(this.props.match.params.projectId) });
      this.fetchData()
    }
    if (prevProps.reportStores !== this.props.reportStores) {
      const hasNoSelection =
        this.state.selectedStore !== "All" && this.state.selectedStore.length === 0;

      if (hasNoSelection) {
        this.setState({ selectedStore: "All" });
      }
    }
  }

  fetchData = () => {
    const projectId = parseInt(this.props.match.params.projectId);

    if (projectId !== -1) {
      this.props.fetchReportStores(projectId, -1);
    }
  };




  handleProjectSelect = (option: FilterOptions) => {
    const projectId = option?.id ?? -1;
    this.setState({ selectedProjectId: projectId, selectedStore: "All" }); // resets "All" too
    if (projectId !== -1) {
      this.props.fetchReportStores(this.state.projectId, projectId);
    }
  };

  handleStoreChange = (ids: number | number[] | "All") => {
    if (ids === "All") {
      this.setState({ selectedStore: "All" });
      return;
    }
    const newIds = Array.isArray(ids) ? ids : [ids];
    this.setState({ selectedStore: newIds }); 
  };

  render() {
    const { selectedReportType, selectedProjectId, selectedStore, projectId } = this.state;
    const { storesLoading, reportStores } = this.props;

    const controllersStyle: React.CSSProperties = {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      height: "100%",
      minHeight: "100%",
      justifyContent:"space-between",
      alignItems: "center",
    };
    const controllerDropdownStyle: React.CSSProperties ={
      flex:"0 0 300px",
      display: "flex",
      flexDirection: "row",
      justifyContent:"space-between"
    }

    const btnControllerStyle :React.CSSProperties = {
      background:"#FFFFFF",
      padding:"15px 30px 15px 27px",
      borderRadius:"13px",
      height:"fit-content",
    }

    return (
        <div>
          <div className="reports-controls" style={controllersStyle}>
            <div className="reports-buttons-wrapper" style={btnControllerStyle}>
              <div className="reports-button-set">
              {this.reportBtns.map((each, i) => (
                <div
                  className="report-btn"
                  key={i}
                  onClick={() => this.handleSelect(each.type)}
                  title={each.description}
                  style={{
                    background:
                      selectedReportType === each.type ? "#D1A33C" : "",
                    fontWeight:selectedReportType === each.type ? 600 : 400,
                    cursor: "pointer",
                  }}
                >
                  {each.label}
                </div>
              ))}
            </div>
          </div>

          {this.state.projectId > 0 ? (
            <div className="reports-filters" style={controllerDropdownStyle}>
              <div className="filter-block" style={{ width: "175px", marginRight: "8px" }}>
                <div className="header-controller-dropdown">Stores</div>
                <ReportsMultiSelect
                  key={selectedProjectId}   
                  initstates={reportStores?.commonStores || []}
                  value={selectedStore === "All" ? -1 : selectedStore}
                  onChange={(ids) => this.handleStoreChange(ids as number[])}
                  multiSelect={true}
                  isDisabled={storesLoading}
                  hideHeader={true}
                />
              </div>

              <div className="filter-block" style={{width: "175px"}}>
                <div className="header-controller-dropdown">
                  Prior Project for Comparison
                </div>
                <ProjectFilter
                  name="reports-project-filter"
                  value={selectedProjectId}
                  isSearchable
                  minHeight={44}
                  minWidth={175}
                  noShadow={true}
                  isReport={true}
                  projectId={parseInt(this.props.match.params.projectId)}
                  onChange={(opt: FilterOptions) => this.handleProjectSelect(opt)}
                />
              </div>
            </div>
          ) : (
            <div />
          )}
        </div>

        {projectId > -1 ? (
          <div className="report-content">
            {this.renderSelectedReportContent(projectId)}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }

  renderSelectedReportContent = (projectId:number) =>{
    const selectedStores = this.state.selectedStore === "All" ? [] : this.state.selectedStore;
    switch (this.state.selectedReportType){
      case "reset-recap":
        return <ResetRecap selectedProjectId={this.state.selectedProjectId} selectedStores={selectedStores} projectId={projectId} />
      case "store-summary":
        return <StoreSummary selectedProjectId={this.state.selectedProjectId} selectedStores={selectedStores} projectId={projectId} />
      case "product-distribution":
        return <ProductDistribution selectedProjectId={this.state.selectedProjectId} selectedStores={selectedStores} projectId={projectId} />
      // case "category-review":
      //   return
      case "segmentation":
        return <SegmentationReport selectedProjectId={this.state.selectedProjectId} selectedStores={selectedStores} projectId={projectId} />
      case "package-summary":
        return <PackageSummary selectedProjectId={this.state.selectedProjectId} selectedStores={selectedStores} projectId={projectId} />
      default:
        return "reset-recap"
    }

  }
}

/* ---------------- Redux ---------------- */
const connecter = connect(
  (state: State) => ({
    projectStores: state.projectStores?.content || [],
    storesLoading: state.reportStores?.loading || false,
    reportStores: state.reportStores?.content || null,
  }),
  { fetchReportStores }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(ManageReports);
